export default __webpack_public_path__ + "static/media/SS4-min.fb643f00.png";